import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";
import { SecurityProviderId, SecurityProviderId_Native, SyncronisationType } from "../../../../Providers.StaticData/StaticDataProvider";

export class Role extends ODataSelect
{
    public Id = '';
    public Name = '';
    public DisplayName = '';
    public IdentityProviderId = 0;
    public GroupId = '';
    public IsOwner = false;
    public ApplicationActions: IPermissions = {};
    public '@odata.etag' = '';

    public init(response: any): Role
    {
        Object.assign(this, response);
        this.IsOwner = TypeHelper.toBoolean(response.IsOwner) ?? false;
        this.ApplicationActions = JSON.parse(response.ApplicationActions || '{}');
        return this;
    }

    public toSelect(): string
    {
        return '';
    }
}

export interface INewRole
{
    Id: string;
    Name: string;
    IdentityProviderId: number;
    GroupId: string;
    IsOwner: number;
    '@odata.etag': string;
    ApplicationActions: string,
}

export class IdentityProvider extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public SecurityProviderTypeId: SecurityProviderId = SecurityProviderId_Native;
    public SyncType: SyncronisationType = 'None';
}

export class User extends ODataSelect
{
    public Id = '';
    public UserType = '';
    public Email = '';
    public DisplayName = '';
    public PreferredName = '';
}

export interface IUserDetails
{
    displayName: string;
}

export type IPermissions = Record<string, Record<string, string[]>>;

export interface IAdvancedSecurityEntity
{
    Id: number;
    RecursiveNodes: boolean;
    EventTypeId: number;
    EventType: { DisplayName: string, Name: string };
    Create: number;
    Read: number;
    Update: number;
    Delete: number;
    Lock: number;
    Unlock: number;
    Append: number;
    AppendTo: number;
    Share: number;
}